import api from '../core/api';

export interface PaymentTransaction {
  _id: string;
  serviceKey: string;
  service: string;
  kind: string;
  reference: string;
  paymentMethod: string;
  paymentBucket: 'cash' | 'wallet' | 'card';
  amount: number;
  status: string;
  createdAt: string;
}

export async function getPaymentTransactions(params: {
  method?: string;
  from?: string;
  to?: string;
  page?: number;
  limit?: number;
}) {
  const res = await api.get('/analytics/payment-transactions', { params });
  return res.data as { data: PaymentTransaction[]; meta: { total: number; page: number; limit: number } };
}
